'use strict'

angular
  .module('basalteApp')
  .constant('BAS_PLAYER_DRAWER', {
    EVT_VISIBILITY_CHANGED: 'evtBasPlayerDrawerVisibilityChanged'
  })
